// Header.js

import Logo from "../../02-molecules/logo/Logo";
import SocialMediaIcons from "../../02-molecules/socialMediaIcons/SocialMediaIcons";

const Header = () => {
    return (
    <header>
        <div className="header-container">
            <div className="wrapper">
                <div className="header-content">
                    <div className="header-title">
                        <Logo />
                    </div>

                    <div className="header-about">
                        <p>"Tailor-Made Furniture & Interior Design Services with 40+ years in Industry! “We keep it Simple & Elegant!” You Dream it, We’ll Design it — All in Your Budget!</p>
                    </div>

                    <SocialMediaIcons />

                    <div className="header-scroll__container">
                        <p>scroll</p>
                        <div className="header-scroll__animation">
                            <div></div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </header>
    )
}

export default Header;